import Axios from "axios";
import * as config from "@/constants/config";
import { authHeader } from "@/services/TokenHelper";

export default {
  controller: "sites/",
  GetAllSites: function() {
    return Axios.get(config.API + this.controller, { headers: authHeader() });
  },
  CreateSite: function(newSite) {
    return Axios.post(config.API + this.controller, newSite, {
      headers: authHeader()
    });
  },
  UpdateSite: function(updatedSite) {
    return Axios.put(
      config.API + this.controller + updatedSite.id,
      updatedSite,
      { headers: authHeader() }
    );
  },
  GetProviders: function(siteId) {
    return Axios.get(config.API + this.controller + siteId + "/providers", {
      headers: authHeader()
    });
  },
  GetProviderApiKey: function(providerId) {
    return Axios.get(config.API + "providers/" + providerId + "/apiKey", {
      headers: authHeader()
    });
  },
  GetPublicAccess: function(siteId) {
    return Axios.get(config.API + this.controller + siteId + "/publicaccess", {
      headers: authHeader()
    });
  }
};
